import React from "react";
import PropTypes from "prop-types";
import { useTranslate } from "hooks/translation-hooks";
import { Centered, RightCornerIcon, SplitPanel } from "../../CardsStyled";
import CardCore from "../../CardCore";
import ToolsIcon from "../../../Icons/ToolsIcon";
import StatusIcon from "../../../Icons/StatusIcon";

export const missionCompletedAction = "summary_card-displayed";

export const CurrentSummary = ({
  rawEventDate,
  jobReference,
  moreInformation
}) => {
  const t = useTranslate();

  return (
    <SplitPanel>
      <Centered>
        <RightCornerIcon>
          <StatusIcon status="SAVED" />
        </RightCornerIcon>
        <ToolsIcon />
      </Centered>
      <CardCore
        title={t("summary_card-title")}
        additionalDescription={`${t("summary_card-text_1")} ${jobReference} ${t(
          "summary_card-text_2"
        )} ${moreInformation || ""}`}
        rawEventDate={rawEventDate}
      />
    </SplitPanel>
  );
};

CurrentSummary.propTypes = {
  jobReference: PropTypes.string.isRequired,
  moreInformation: PropTypes.string.isRequired
};

export default CurrentSummary;
